module.exports = __webpack_public_path__ + "1faf80a197d122b7.svg";